import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined,  QuestionCircleOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography, Drawer, Tooltip } from "antd";
import AdjustmentRecordFilters from "./components/AdjustmentRecordFilters";
import AdjustmentRecordTable from "./components/AdjustmentRecordTable";
import { fetchAdjustmentRecord } from "./AdjustmentRecordThunk";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const AdjustmentRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters } = useSelector((state) => state.adjustmentRecord);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAdjustmentRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Adjustment Record Report",
    removeAfterPrint: true,
  });

  const handleNavigateToBack = () => {
    navigate(-1);
  }

  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          // title={<div style={{ display: "flex", alignItems: "center" }}>
          //   <Button
          //     type="text"
          //     icon={<ArrowLeftOutlined />}
          //     onClick={handleNavigateToBack}
          //     style={{ marginRight: 8 }}
          //   /><Title level={4} style={{ margin: 0 }}>Adjustment Record</Title>
          //   </div>}
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="text"
                  icon={<ArrowLeftOutlined />}
                  onClick={handleNavigateToBack}
                  style={{ marginRight: 8 }}
                />

                <Title level={4} style={{ margin: 0 }}>
                  Adjustment Record
                </Title>
              </div>

              <Tooltip title="Help">
                <Button
                  type="text"
                  icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                  onClick={() => setHelpOpen(true)}
                />
              </Tooltip>
            </div>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <AdjustmentRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <AdjustmentRecordTable />
        </Card>
      </App>
      
      <Drawer
        title="Adjustment Record Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Adjustment Record Report
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Adjustment Record Report module is used to view and track
            inventory adjustment transactions within the ERP system. It helps
            monitor stock corrections, quantity updates, and inventory
            modification history for auditing and reporting purposes.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to View Adjustment Records</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Inventory → Adjustment Record</strong></li>
              <li>Select required filters and date range</li>
              <li>Search adjustment entries if needed</li>
              <li>Review adjusted item quantities and stock changes</li>
              <li>Verify voucher references and adjustment details</li>
              <li>Analyze inventory correction history</li>
              <li>Use Print option to generate report copy if required</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Adjustment records update automatically after stock changes.</li>
              <li>Filters can be used to narrow report results.</li>
              <li>Printed reports reflect current adjustment data.</li>
              <li>Adjustment history helps maintain inventory accuracy.</li>
            </ul>
          </div>
        </div>
      </Drawer>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Adjustment Record Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <AdjustmentRecordTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default AdjustmentRecord;
